import { all, fork } from 'redux-saga/effects';

import watchMetaData from '~/containers/MetaDataProvider/saga';
import watchAuth from '~/containers/AuthProvider/saga';
import watchCategoryPageContainer from '~/containers/CategoryPageContainer/saga';
import watchTemplatePageContainer from '~/containers/TemplatePageContainer/saga';
import watchHomePageContainer from '~/containers/HomePageContainer/saga';
import watchTemplatePreviewContainer from '~/containers/TemplatePreviewContainer/saga';

export default function* rootSaga() {
  yield all([
    fork(watchMetaData),
    fork(watchAuth),
    fork(watchCategoryPageContainer),
    fork(watchTemplatePageContainer),
    fork(watchHomePageContainer),
    fork(watchTemplatePreviewContainer),
  ]);
}
